import { FirebaseAnalytics, FirebaseInitOptions } from "@capacitor-community/firebase-analytics";

function fakeInitializeFirebase(_options: FirebaseInitOptions) {
  console.log("[fake:firebase-analytics] initialize");
  return Promise.resolve();
}

function fakeLogEvent(options: { name: string; params: object }) {
  console.log("[fake:firebase-analytics] log", options);
  return Promise.resolve();
}

function fakeSetUserId(options: { userId: string }) {
  console.log("[fake:firebase-analytics] set user", options);
  return Promise.resolve();
}

const FakeFirebaseAnalytics = {
  initializeFirebase: fakeInitializeFirebase,
  logEvent: fakeLogEvent,
  setUserId: fakeSetUserId,
};

export default import.meta.env.PROD ? FirebaseAnalytics : FakeFirebaseAnalytics;
